import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import '../../../../assets/css/superadmin/dashboard/dashboardchart/DashboardChart.css';

const DashboardChart = ({ chartData }) => {
  const [chartView, setChartView] = useState('weekly');

  const weeklyData = chartData?.weekly ?? [];
  const monthlyData = chartData?.monthly ?? [];

  return (
    <div className="chart-card">
      <div className="chart-header">
        <div className="chart-title-section">
          <h3 className="chart-title">Active Chart</h3>
          <p className="chart-subtitle">Show Weekly and Monthly Progress in Active Rentals and Mechanics </p>
        </div>
        <div className="chart-controls">
          <button
            className={`chart-btn ${chartView === 'weekly' ? 'active' : ''}`}
            onClick={() => setChartView('weekly')}
          >
            Weekly
          </button>
          <button
            className={`chart-btn ${chartView === 'monthly' ? 'active' : ''}`}
            onClick={() => setChartView('monthly')}
          >
            Monthly
          </button>
        </div>
      </div>

      <div className="chart-container">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartView === 'weekly' ? weeklyData : monthlyData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#F0F0F0" />
            <XAxis dataKey="name" stroke="#666" style={{ fontSize: '12px' }} />
            <YAxis stroke="#666" style={{ fontSize: '12px' }} />
            <Tooltip
              contentStyle={{
                background: '#FFF',
                border: '1px solid #E5E5E5',
                borderRadius: '8px',
                fontSize: '12px'
              }}
            />
            <Legend wrapperStyle={{ fontSize: '13px', paddingTop: '10px' }} />
            <Line
              type="monotone"
              dataKey="rentals"
              stroke="#E5A512"
              strokeWidth={3}
              name="Rentals"
              dot={{ fill: '#E5A512', r: 4 }}
            />
            <Line
              type="monotone"
              dataKey="maintenance"
              stroke="#999"
              strokeWidth={2}
              strokeDasharray="5 5"
              name="Maintenance"
              dot={{ fill: '#999', r: 3 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DashboardChart;